import palette from '@theme/assets/palette';

export const form = {
    variants: {
        floating: {
            container: {
                paddingBottom: '10px',
                _focusWithin: {
                    label: {
                        transform: 'scale(0.85) translateY(-24px)',
                        color: palette.black,
                        width: 'auto',
                    },
                },
                'input:not(:placeholder-shown) + label, .chakra-select__wrapper + label, .selectComponent + label, textarea:not(:placeholder-shown) ~ label, .gattinoni_datePicker.filled + label':
                    {
                        transform: 'scale(0.85) translateY(-24px)',
                        width: 'auto',
                        color: palette.black,
                    },
                label: {
                    top: 0,
                    left: 0,
                    zIndex: 2,
                    position: 'absolute',
                    backgroundColor: 'white',
                    pointerEvents: 'none',
                    mx: 3,
                    px: 1,
                    my: 2,
                    transformOrigin: 'left top',
                    color: palette.ui03,
                    width: 'calc(100% - 38px)',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',

                    '.chakra-form__required-indicator': {
                        opacity: 0,
                        width: 0,
                        height: 0,
                    },
                },
            },
        },
    },
};
